import React from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, bool, shape, string } from 'prop-types'

import MosaicItem from './Components/MosaicItem'

function ImageMosaic({ images, staggered = false, lazy = false }) {
  if (!images?.length || images.length < 4) {
    return null
  }

  return (
    <div className={classnames('image-mosaic', staggered && 'image-mosaic--staggered')}>
      <div className="image-mosaic-column">
        <MosaicItem image={images[0]} size="tall" lazy={lazy} />
        <MosaicItem image={images[2]} size="short" lazy={lazy} />
      </div>
      <div className="image-mosaic-column">
        <MosaicItem image={images[1]} size="short" lazy={lazy} />
        <MosaicItem image={images[3]} size="tall" lazy={lazy} />
      </div>
    </div>
  )
}

ImageMosaic.propTypes = {
  images: arrayOf(
    shape({
      id: string.isRequired,
      url: string,
      alt: string.isRequired,
    })
  ).isRequired,
  staggered: bool,
  lazy: bool,
}

export default ImageMosaic
